<template>
  <div class="account-income">
    <pageTitle :pageTitle="$t('lang.k_133001')">
      <div slot="content">
        {{ $t('lang.k_133002') }}
        <br />
        {{ $t('lang.k_133003') }}
      </div>
    </pageTitle>
    <div class="box-card">
      <vh-tabs v-model="activeIndex" @tab-click="handleClick">
        <vh-tab-pane :label="$t('lang.k_133004')" name="1"></vh-tab-pane>
        <vh-tab-pane :label="$t('lang.k_133005')" name="2"></vh-tab-pane>
        <div class="search-box">
          <search-area
            ref="searchDetail"
            :searchAreaLayout="searchDetail"
            @onExportData="exportAccount()"
            @onSearchFun="getSearchList('search')"
          ></search-area>
        </div>
        <div class="interact-detail">
          <vh-table
            @cell-mouse-enter="handleCellMouseEnter"
            @cell-mouse-leave="handleCellMouseLeave"
            :data="tableList"
            v-if="isDetail"
            style="width: 100%"
            :header-cell-style="{ background: '#f7f7f7', color: '#666', height: '56px' }"
          >
            <vh-table-column
              :prop="activeIndex == 1 ? 'order_id' : 'id'"
              :label="$t('lang.k_133006')"
              min-width="145"
            ></vh-table-column>
            <vh-table-column :label="$t('lang.k_133007')" width="180">
              <template slot-scope="scope">
                <vh-tooltip
                  placement="top"
                  :disabled="!isTextOverflow"
                  :content="scope.row.create_time == '' ? '- -' : scope.row.create_time"
                >
                  <p class="custom-tooltip-content">
                    {{ scope.row.create_time == '' ? '- -' : scope.row.create_time }}
                  </p>
                </vh-tooltip>
              </template>
            </vh-table-column>
            <vh-table-column prop="type" :label="$t('lang.k_133008')" width="150">
              <template slot-scope="scope">{{ $t(scope.row.type) }}</template>
            </vh-table-column>
            <vh-table-column
              prop="amount"
              v-if="activeIndex == 1"
              :label="$t('lang.k_133009')"
              width="120"
            ></vh-table-column>
            <vh-table-column prop="content" :label="$t('lang.k_133010')" width="120">
              <template slot-scope="scope">{{ formatContent(scope.row.content) }}</template>
            </vh-table-column>
            <vh-table-column :label="$t('lang.k_133011')" v-if="activeIndex == 1" width="120">
              <template slot-scope="scope">
                <span class="buyStatus">
                  <i
                    :class="
                      scope.row.status == 1
                        ? 'active-success'
                        : scope.row.status == -1
                        ? 'active-error'
                        : 'active-waiting'
                    "
                  ></i>
                  {{ scope.row.statusText }}
                </span>
              </template>
            </vh-table-column>
            <vh-table-column v-if="activeIndex == 2" :label="$t('lang.k_133011')" width="120">
              <template slot-scope="scope">
                <span class="buyStatus">
                  <i
                    :class="
                      scope.row.status == 1
                        ? 'active-success'
                        : scope.row.status == -1
                        ? 'active-error'
                        : 'active-waiting'
                    "
                  ></i>
                  {{ scope.row.statusText }}
                </span>
              </template>
            </vh-table-column>
            <vh-table-column v-if="activeIndex == 2" :label="$t('lang.k_133012')" width="120">
              <template slot-scope="scope">
                <span>{{ scope.row.source | filterSource }}</span>
              </template>
            </vh-table-column>
            <vh-table-column :label="$t('lang.k_133013')" width="180">
              <template slot-scope="scope">
                <vh-tooltip
                  placement="top"
                  :disabled="!isTextOverflow"
                  :content="scope.row.start_time == '' ? '- -' : scope.row.start_time"
                >
                  <p class="custom-tooltip-content">
                    {{ scope.row.start_time == '' ? '- -' : scope.row.start_time }}
                  </p>
                </vh-tooltip>
              </template>
            </vh-table-column>
            <vh-table-column :label="$t('lang.k_133014')" width="180">
              <template slot-scope="scope">
                <vh-tooltip
                  placement="top"
                  :disabled="!isTextOverflow"
                  :content="scope.row.end_time == '' ? '- -' : scope.row.end_time"
                >
                  <p class="custom-tooltip-content">
                    {{ scope.row.end_time == '' ? '- -' : scope.row.end_time }}
                  </p>
                </vh-tooltip>
              </template>
            </vh-table-column>
            <vh-table-column
              width="130"
              v-if="activeIndex == 1 && totalNum"
              fixed="right"
              :label="$t('lang.k_133015')"
            >
              <template slot-scope="scope">
                <vh-button type="text" @click="deleteOrder(scope.row)">
                  {{ $t('lang.k_133016') }}
                </vh-button>
                <vh-button type="text" @click="pay(scope.row)" v-if="!scope.row.status">
                  {{ $t('lang.k_133017') }}
                </vh-button>
              </template>
            </vh-table-column>
            <div slot="empty">
              <noData :nullType="'nullData'" v-if="!totalNum" :text="$t('lang.k_133018')"></noData>
            </div>
          </vh-table>
          <SPagination
            :total="totalNum"
            :currentPage="pageInfo.pageNum"
            :page-size="pageInfo.limit"
            @current-change="currentChangeHandler"
            @size-change="sizeChange"
          ></SPagination>
        </div>
        <!-- <table-list
          v-show="activeIndex==2"
          ref="tableDetail"
          :manageTableData="tableList"
          :tabelColumnLabel="tabelColumnes"
          :isCheckout="false"
          :isHandle="false"
          :totalNum="totalNum"
          @getTableList="getDetailList"
          >
        </table-list> -->
        <!-- <noData :nullType="'nullData'" v-if="!totalNum&&activeIndex==2" :text="'暂无数据'" :height="100"></noData> -->
      </vh-tabs>
    </div>
  </div>
</template>

<script>
  import PageTitle from '@/components/PageTitle';
  import { sessionOrLocal } from '@/utils/utils';
  import noData from '@/views/PlatformModule/Error/nullPage';
  import tableCellTooltip from '@/components/TableList/mixins/tableCellTooltip';
  import { scope } from '@babel/traverse/lib/cache';
  export default {
    name: 'income',
    mixins: [tableCellTooltip],
    data() {
      return {
        activeIndex: '1',
        totalNum: 0,
        isDetail: false,
        isHandle: true,
        params: {},
        pageInfo: {
          pageNum: 1,
          limit: 10,
          pos: 0
        },
        options: [
          {
            label: this.$t('lang.k_133019'),
            value: ''
          },
          {
            label: this.$t('lang.k_133020'),
            value: 'flow'
          },
          {
            label: this.$t('lang.k_133021'),
            value: 'concurrency'
          },
          {
            label: this.$t('lang.k_133022'),
            value: 'extend_people'
          },
          {
            label: this.$t('lang.k_133023'),
            value: 'extend_day'
          },
          {
            label: this.$t('lang.k_133024'),
            value: 'duration'
          },
          {
            label: this.$t('lang.k_133025'),
            value: '19'
          }
        ],

        orderOptions: [
          {
            label: this.$t('lang.k_133020'),
            value: 'flow'
          },
          {
            label: this.$t('lang.k_133026'),
            value: 'concurrency'
          },
          {
            label: this.$t('lang.k_133022'),
            value: 'extend_people'
          },
          {
            label: this.$t('lang.k_133023'),
            value: 'extend_day'
          },
          {
            label: this.$t('lang.k_133024'),
            value: 'duration'
          }
        ],

        // 购买明细
        searchList: [
          {
            type: '2',
            key: 'searchTime'
          },
          {
            type: '3',
            key: 'orderType',
            placeholder: this.$t('lang.k_133008'),
            options: [
              {
                label: this.$t('lang.k_133019'),
                value: ''
              },
              {
                label: this.$t('lang.k_133027'),
                value: 7
              },
              {
                label: this.$t('lang.k_133028'),
                value: 8
              },
              {
                label: this.$t('lang.k_133021'),
                value: 10
              },
              {
                label: this.$t('lang.k_133020'),
                value: 11
              },
              {
                label: this.$t('lang.k_133029'),
                value: 12
              },
              {
                label: this.$t('lang.k_133030'),
                value: 13
              },
              {
                label: this.$t('lang.k_133031'),
                value: 14
              },
              {
                label: this.$t('lang.k_133032'),
                value: 15
              },
              {
                label: this.$t('lang.k_133033'),
                value: 16
              }
            ]
          },
          {
            type: '3',
            key: 'status',
            placeholder: this.$t('lang.k_133011'),
            options: [
              {
                label: this.$t('lang.k_133019'),
                value: ''
              },
              {
                label: this.$t('lang.k_133034'),
                value: -1
              },
              {
                label: this.$t('lang.k_133035'),
                value: 0
              },
              {
                label: this.$t('lang.k_133036'),
                value: 1
              }
            ]
          },
          {
            type: '6'
          }
        ],

        // 开通明细
        searchOrder: [
          {
            type: '2',
            key: 'searchTime'
          },
          {
            type: '3',
            key: 'orderType',
            placeholder: this.$t('lang.k_133008'),
            options: []
          },
          {
            type: '3',
            key: 'status',
            placeholder: this.$t('lang.k_133011'),
            options: [
              {
                label: this.$t('lang.k_133019'),
                value: ''
              },
              {
                label: this.$t('lang.k_133037'),
                value: 0
              },
              {
                label: this.$t('lang.k_133038'),
                value: 1
              },
              {
                label: this.$t('lang.k_133039'),
                value: -1
              }
            ]
          },
          {
            type: '3',
            key: 'source',
            placeholder: this.$t('lang.k_133040'),
            options: [
              {
                label: this.$t('lang.k_133019'),
                value: ''
              },
              {
                label: this.$t('lang.k_133041'),
                value: 5
              },
              {
                label: this.$t('lang.k_133042'),
                value: 6
              },
              {
                label: this.$t('lang.k_133043'),
                value: 7
              },
              {
                label: this.$t('lang.k_133044'),
                value: 8
              },
              {
                label: this.$t('lang.k_133045'),
                value: 9
              },
              {
                label: this.$t('lang.k_133046'),
                value: 10
              }
            ]
          },
          {
            type: '6'
          }
        ],

        searchDetail: [],
        tableList: [],
        tabelColumnes: [
          {
            label: this.$t('lang.k_133006'),
            key: 'id',
            width: 90
          },
          {
            label: this.$t('lang.k_133007'),
            key: 'create_time'
          },
          {
            label: this.$t('lang.k_133008'),
            key: 'type',
            width: 90
          },
          {
            label: this.$t('lang.k_133010'),
            key: 'content',
            width: 95,
            customTooltip: true
          },
          {
            label: this.$t('lang.k_133011'),
            key: 'status',
            width: 95
          },
          {
            label: this.$t('lang.k_133012'),
            key: 'source',
            width: 95
          },
          {
            label: this.$t('lang.k_133013'),
            key: 'start_time'
          },
          {
            label: this.$t('lang.k_133014'),
            key: 'end_time'
          }
        ]
      };
    },
    computed: {
      showSmsModule: function () {
        const userInfo = JSON.parse(sessionOrLocal.get('userInfo'));
        const isNoticeMessage = JSON.parse(sessionOrLocal.get('SAAS_VS_PES', 'localStorage'))[
          'message_notice'
        ];

        // 不是知学云账号 & 开启了 短信通知配置项权限
        return userInfo.user_extends.extends_remark != 1 && isNoticeMessage == 1;
      }
    },
    components: {
      PageTitle,
      noData
    },
    mounted() {
      this.userId = JSON.parse(sessionOrLocal.get('userId'));
      this.tabelColumn = this.tabelColumns;
      this.searchDetail = this.searchList;
      this.getDetailList();
    },
    watch: {
      activeIndex(value) {
        if (parseInt(value) === 2) {
          // 开通明细
          this.getRoleList();
        } else {
          // 购买明细
          this.searchDetail = this.searchList;
        }
      }
    },
    methods: {
      formatContent(val) {
        if (this.$i18n.locale === 'en') {
          val = (val + '').replaceAll('条', ' Pieces').replaceAll('方', ' Parties');
        }
        return val;
      },
      getRoleList() {
        let arrList = JSON.parse(JSON.stringify(this.options));
        if (!this.showSmsModule) {
          // 如果是知学云，不考虑短信数据
          arrList = arrList.filters(item => Number(item.value) != 19);
        }
        this.$fetch('getRoleRbacList', { category_id: 1, limit: 50, pos: 0 }).then(res => {
          res.data.list.map(item => {
            arrList.push({
              label: this.$t(item.role_name),
              value: item.id,
              k: item.id
            });
          });
        });
        this.searchOrder.map(item => {
          if (item.key === 'orderType') {
            item.options = arrList;
          }
        });
        this.searchDetail = this.searchOrder;
      },
      onHandleBtnClick(val) {
        let methodsCombin = this.$options.methods;
        methodsCombin[val.type](this, val);
      },
      handleClick(tab) {
        this.activeIndex = tab.name;
        this.pageInfo.pos = 0;
        this.pageInfo.pageNum = 1;
        this.isDetail = false;
        // this.$refs.tableDetail.pageInfo.pos = 0;
        // this.$refs.tableDetail.pageInfo.pageNum = 1;
        this.$refs.searchDetail.searchParams = {};
        this.getDetailList();
      },
      getSearchList() {
        let formParams = this.$refs.searchDetail.searchParams;
        console.log(formParams, '?????????');
        for (let i in formParams) {
          if (i === 'searchTime' && formParams.searchTime) {
            this.$vhall_paas_port({
              k: this.activeIndex == 1 ? 100708 : 100724,
              data: {
                business_uid: this.userId,
                user_id: '',
                webinar_id: '',
                refer: '',
                s: '',
                report_extra: {},
                ref_url: '',
                req_url: ''
              }
            });
          }
          if (i === 'orderType') {
            let k = 100709;
            let typeOrder = [
              100710,
              100711,
              '',
              100712,
              100713,
              100714,
              100715,
              100716,
              100466,
              100467
            ];
            let typeDetail = [
              100730, 100731, 100732, 100733, 100734, 100735, 100736, 100737, 100726, 100727,
              100728, 100729
            ];
            if (this.activeIndex == 1) {
              k = formParams.orderType ? typeOrder[formParams.orderType - 7] : 100709;
            } else {
              if (typeof formParams.orderType == 'number') {
                if (formParams.orderType > 8) {
                  k = 104000;
                } else {
                  k = typeDetail[formParams.orderType];
                }
              } else {
                let type = formParams.orderType;
                k =
                  type === 'flow'
                    ? 100726
                    : type === 'concurrency'
                    ? 100727
                    : type === 'extend_people'
                    ? 100728
                    : type === 'extend_day'
                    ? 100729
                    : 100725;
              }
            }
            this.$vhall_paas_port({
              k: k,
              data: {
                business_uid: this.userId,
                user_id: '',
                webinar_id: '',
                refer: '',
                s: '',
                report_extra: {},
                ref_url: '',
                req_url: ''
              }
            });
          }
          if (i === 'status') {
            let k = this.activeIndex == 1 ? 100717 : 100738;
            if (formParams.status === 1) {
              k = this.activeIndex == 1 ? 100720 : 100740;
            } else if (formParams.status === -1) {
              k = this.activeIndex == 1 ? 100718 : 100741;
            } else if (formParams.status === 0) {
              k = this.activeIndex == 1 ? 100719 : 100739;
            }
            this.$vhall_paas_port({
              k: k,
              data: {
                business_uid: this.userId,
                user_id: '',
                webinar_id: '',
                refer: '',
                s: '',
                report_extra: {},
                ref_url: '',
                req_url: ''
              }
            });
          }
          if (i === 'source' && this.activeIndex == 2) {
            let sourceArr = [100743, 100744, 100745, 100746, 100747, 100748];
            this.$vhall_paas_port({
              k: formParams.source ? sourceArr[formParams.source - 5] : 100742,
              data: {
                business_uid: this.userId,
                user_id: '',
                webinar_id: '',
                refer: '',
                s: '',
                report_extra: {},
                ref_url: '',
                req_url: ''
              }
            });
          }
        }
        this.getDetailList('search');
      },
      getDetailList(params) {
        // let pageInfo = {};
        // if (this.activeIndex == 1) {
        //   pageInfo = this.pageInfo;
        // } else {
        //   pageInfo = this.$refs.tableDetail.pageInfo;
        // }
        let formParams = this.$refs.searchDetail.searchParams; //获取搜索参数
        let paramsObj = {
          user_id: this.userId
        };
        if (params === 'search') {
          this.pageInfo.pos = 0;
          this.pageInfo.pageNum = 1;
        }
        for (let i in formParams) {
          if (i === 'searchTime' && formParams.searchTime) {
            paramsObj['start_time'] = formParams[i][0];
            paramsObj['end_time'] = formParams[i][1];
          } else {
            paramsObj[i] = formParams[i];
          }
        }
        paramsObj.type = formParams.orderType || '';
        paramsObj = this.formatSmsQuery(paramsObj); // 短信查询入参格式化
        let obj = Object.assign({}, this.pageInfo, paramsObj);
        this.params = paramsObj;
        let url = this.activeIndex == 1 ? 'buyDetail' : 'orderDetail';
        this.$fetch(url, this.$params(obj))
          .then(res => {
            this.totalNum = res.data.total;
            let tableList = res.data.list;
            if (res.data.total > 0) {
              tableList.map(item => {
                if (this.activeIndex == 1) {
                  item.statusText =
                    item.status == 1
                      ? this.$t('lang.k_133036')
                      : item.status == -1
                      ? this.$t('lang.k_133034')
                      : this.$t('lang.k_133035');
                  item.type = this.culesType(item.type);
                } else {
                  item.statusText =
                    item.status == 1
                      ? this.$t('lang.k_133038')
                      : item.status == -1
                      ? this.$t('lang.k_133039')
                      : this.$t('lang.k_133047');
                  // item.source = this.buyMethods(item.source);
                }
              });
            }
            this.tableList = tableList;
            this.isDetail = true;
            console.log(this.tableList, '????kaitongmingxi开通明细');
            if (this.tableList.length == 0) {
              //兼容有无数据来修改element样式
              document.querySelector('.vh-table').style.position = 'inherit';
            } else {
              document.querySelector('.vh-table').style.position = 'relative';
            }
          })
          .catch(e => {
            console.log(e);
          });
      },
      formatSmsQuery(obj) {
        try {
          if (this.activeIndex != 1) {
            // 如果当前是 开通明细，当前是短信包，传递一个serviceType传递，否则不需要
            if (obj.type == 19) {
              delete obj.orderType;
              delete obj.type;
              obj.serviceType = 19;
            } else {
              delete obj.serviceType;
            }
          }
        } catch (e) {
          // 去除无效key
        }
        return obj;
      },
      // 页码改变按钮事件
      currentChangeHandler(current) {
        this.pageInfo.pageNum = current;
        this.pageInfo.pos = parseInt((current - 1) * this.pageInfo.limit);
        this.getDetailList();
      },
      // 页码改变按钮事件
      sizeChange(current) {
        this.pageInfo.pageNum = 1;
        this.pageInfo.limit = current;
        this.pageInfo.pos = 0;
        this.getDetailList();
      },
      buyMethods(source) {
        let arrType = [
          this.$t('lang.k_133041'),
          this.$t('lang.k_133042'),
          this.$t('lang.k_133043'),
          this.$t('lang.k_133044'),
          this.$t('lang.k_133048'),
          this.$t('lang.k_133046')
        ];
        return arrType[source - 5];
      },
      culesType(type) {
        // 购买
        let name = '';
        this.searchDetail.map(item => {
          if (item.key === 'orderType') {
            item.options.map(items => {
              if (items.value == type) {
                name = items.label;
              }
            });
          }
        });
        return name;
      },
      deleteOrder(rows) {
        this.$vhConfirm(this.$t('lang.k_133049'), this.$t('lang.k_133050'), {
          confirmButtonText: this.$t('lang.k_133051'),
          cancelButtonText: this.$t('lang.k_133052'),
          roundButton: true,
          customClass: 'zdy-message-box',
          lockScroll: false,

          cancelButtonClass: 'zdy-confirm-cancel'
        })
          .then(() => {
            this.deleteList(rows.order_id);
          })
          .catch(() => {
            this.$vhMessage({
              message: `${this.$t('lang.k_133053')}`,
              showClose: true,
              // duration: 0,
              type: 'info',
              customClass: 'zdy-info-box'
            });
          });
      },
      deleteList(id) {
        this.$fetch('deleteDetail', { id: id })
          .then(res => {
            this.$vhall_paas_port({
              k: 100721,
              data: {
                business_uid: this.userId,
                user_id: '',
                webinar_id: '',
                refer: '',
                s: '',
                report_extra: { orderId: id },
                ref_url: '',
                req_url: ''
              }
            });
            this.$vhMessage({
              message: this.$t('lang.k_133054'),
              showClose: true,
              // duration: 0,
              type: 'success',
              customClass: 'zdy-info-box'
            });
            this.getDetailList();
          })
          .catch(e => {
            console.log(e);
            this.$vhMessage({
              message: e.msg || this.$t('lang.k_133055'),
              showClose: true,
              // duration: 0,
              type: 'error',
              customClass: 'zdy-info-box'
            });
          });
      },
      pay(rows) {
        this.$vhall_paas_port({
          k: 100722,
          data: {
            business_uid: this.userId,
            user_id: '',
            webinar_id: '',
            refer: '',
            s: '',
            report_extra: {},
            ref_url: '',
            req_url: ''
          }
        });
        this.$router.push({
          path: '/plan/payOrder',
          query: {
            userId: this.userId,
            orderId: rows.order_id
          }
        });
      },
      // 导出账单明细
      exportAccount() {
        let url = this.activeIndex == '1' ? 'exporOrder' : 'exportAdmin';
        this.$fetch(url, this.$params(this.params))
          .then(res => {
            this.$vhall_paas_port({
              k: this.activeIndex == '1' ? 100707 : 100723,
              data: {
                business_uid: this.userId,
                user_id: '',
                webinar_id: '',
                refer: '',
                s: '',
                report_extra: {},
                ref_url: '',
                req_url: ''
              }
            });
            this.$vhMessage({
              message: this.$t('lang.k_133056', [
                this.activeIndex == 1 ? this.$t('lang.k_133057') : this.$t('lang.k_133058'),
                this.$store.state.permissionValue.custom_download_toast || this.$t('lang.k_133059')
              ]),

              showClose: true,
              // duration: 0,
              type: 'success',
              customClass: 'zdy-info-box'
            });
            this.$EventBus.$emit('saas_vs_download_change');
          })
          .catch(res => {
            this.$vhMessage({
              message:
                res.msg ||
                this.$t('lang.k_133060', [
                  this.activeIndex == 1 ? this.$t('lang.k_133057') : this.$t('lang.k_133058')
                ]),
              showClose: true,
              // duration: 0,
              type: 'error',
              customClass: 'zdy-info-box'
            });
          });
      }
    }
  };
</script>

<style lang="less" scoped>
  .account-income {
    .interact-detail {
      min-height: 550px;
    }
    .box-card {
      padding: 0 0 40px 0;
      border-radius: 4px;
      background: #fff;
    }
    .search-box {
      padding-top: 30px;
    }
    .pageBox {
      margin-top: 20px;
    }

    ::v-deep .vh-select {
      width: 140px !important;
    }
    .buyStatus {
      i {
        display: inline-block;
        width: 8px;
        height: 8px;
        border-radius: 50%;
        vertical-align: middle;
        margin-right: 5px;
        margin-top: -3px;
        &.active-success {
          background: #14ba6a;
        }
        &.active-error {
          background: #fb3a32;
        }
        &.active-waiting {
          background: #fa9a32;
        }
      }
    }
  }
</style>
